<template>
  <sc-page-base :loading="loading">
    <div class="columns">
      <div class="column is-12">
        <sc-steps v-model="activeStep" size="is-medium" :has-navigation="false">
          <sc-step-item label="Credenciais na transportadora" step="1" :clickable="false">
            <sc-credentials />
          </sc-step-item>
          <sc-step-item label="Configurações de envio" step="2" :clickable="false">
            <sc-config-sysnode />
          </sc-step-item>
          <sc-step-item label="Contatos" step="3" :clickable="false">
            <sc-contact />
          </sc-step-item>
          <sc-step-item label="Credenciais na Intelipost" step="4" :clickable="false">
            <sc-data-carrier />
          </sc-step-item>
          <sc-step-item label="Testes" step="5" :clickable="false">
            <sc-test />
          </sc-step-item>
          <sc-step-item label="Concluído" step="6" :clickable="false">
            <sc-finished />
          </sc-step-item>
        </sc-steps>
      </div>
    </div>
  </sc-page-base>
</template>
  
<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScSteps,
    ScStepItem,
    ScPageBase,
  } from '@intelipost-js/secure-components';
  
  import ScCredentials from '../sc-credentials/ScCredentials.vue';
  import ScConfigSysnode from '../sc-config-sysnode/ScConfigSysnode';
  import ScContact from '../sc-contact/ScContact';
  import ScDataCarrier from '../sc-data-carrier/ScDataCarrier';
  import ScTest from '../sc-test/ScTest';
  import ScFinished from '../sc-finished/ScFinished';

  const { mapState } = createNamespacedHelpers('integrations/integrationsStep');

  export default {
    name: 'sc-step',

    computed: {
      ...mapState([
        'activeStep',
        'loading',
      ]),
    },
    components: {
      ScSteps,
      ScStepItem,
      ScCredentials,
      ScConfigSysnode,
      ScContact,
      ScDataCarrier,
      ScTest,
      ScFinished,
      ScPageBase,
    },
  };
</script>
  


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-step/ScStep.vue